import { render, staticRenderFns } from "./yuyueIndex.vue?vue&type=template&id=1dddf4dc&scoped=true&"
import script from "./yuyueIndex.vue?vue&type=script&lang=js&"
export * from "./yuyueIndex.vue?vue&type=script&lang=js&"
import style0 from "./yuyueIndex.vue?vue&type=style&index=0&id=1dddf4dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dddf4dc",
  null
  
)

export default component.exports